import * as React from "react";
import { forwardRef } from "react";
const ExternalArrowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.61538.6c0-.331371.26863-.6.6-.6H15.4c.0207 0 .0412.00104933.0613.00309773C15.7639.0338237 16 .28934 16 .6v6.18462c0 .33137-.2686.6-.6.6h-1.2615c-.3314 0-.6-.26863-.6-.6V4.65005L9.54944 8.63906c-.23431.23431-.61421.23431-.84853 0l-.89204-.89204c-.23431-.23432-.23431-.61422 0-.84853l4.43693-4.43695H9.21538c-.33137 0-.6-.26863-.6-.6z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m1.27951 0-.00064.00000407H.6c-.331371 0-.6.26862993-.6.59999993V15.4c0 .3314.268629.6.6.6h15.3391c.0336 0 .0609-.0272.0609-.0609V11.077c0-.6798-.551-1.23081-1.2308-1.23081-.6797 0-1.2307.55101-1.2307 1.23081v2.4615H2.46154V2.46154h2.46153c.67974 0 1.23077-.55104 1.23077-1.23077C6.15384.551034 5.60281 0 4.92307 0z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(ExternalArrowIcon);
export { ForwardRef as ExternalArrowIcon };